// extracted by mini-css-extract-plugin
module.exports = {"lia-list-header":"GuidesWidget_lia-list-header__zuuig"};